import { useAtomValue } from 'jotai';
import { useNavigate } from 'react-router';
import { ROUTES } from '../../../constants/RouteNameMapping';
import { useFieldManagerAvailable } from '../../AdminPanel/FieldManager/useFieldManagerAvailable';
import { GenericConfigPage } from '../Common/GenericConfigPage';
import { kpiGroupsState } from '../../../services/state/KPI/KPITemplatesStateJ';
import { SortKPIGroups } from '../KPI/KPIManageGroups';
import { getKPIGroupFields } from './KPIGroupFields';

export const KPIGroupConfigBaseURL = '/kpiGroupConfig';

export function ConfigKPIGroups() {
  const kpiGroups = useAtomValue(kpiGroupsState);
  const navigate = useNavigate();
  // The Field Manager's KPIs pill links here via Manage KPI Groups — offer the
  // way back when it is available.
  const fieldManagerAvailable = useFieldManagerAvailable();

  return (
    <GenericConfigPage
      baseTitle={'KPI Group'}
      customToolbarElem={<SortKPIGroups />}
      data={kpiGroups}
      fields={[]}
      formFields={getKPIGroupFields()}
      pageTitle={'KPI Groups'}
      queryURL={KPIGroupConfigBaseURL}
      onBack={
        fieldManagerAvailable
          ? () => navigate(`/${ROUTES.ADMIN_PANEL}/${ROUTES.ADMIN_PANEL_FIELD_MANAGER}`)
          : undefined
      }
    />
  );
}
